/** Ukrainian (`uk`) catalog. */

export const catalogUk: Record<string, string> = {
  "quiz.account.menu_aria_label": "Обліковий запис і вихід",
  "quiz.account.pending_summary": "Акаунт",
  "quiz.home.checking_session": "Перевіряємо, чи ви увійшли...",
  "quiz.home.cta_continue_my_quizzes": "До «Мої тести»",
  "quiz.home.cta_create_quiz_primary": "Створити квіз",
  "quiz.home.cta_sign_in_organizer": "Увійти",
  "quiz.home.footer_aux_aria_label": "Юридичні та довідкові посилання",
  "quiz.home.footer_legal": "© {year} Quiz. Усі права захищено.",
  "quiz.home.footer_link_contact": "Зв'язок",
  "quiz.home.footer_link_help": "Довідковий центр",
  "quiz.home.footer_link_privacy": "Політика конфіденційності",
  "quiz.home.footer_link_terms": "Умови надання послуг",
  "quiz.home.header_sign_in": "Увійти",
  "quiz.home.header_title": "Quiz",
  "quiz.home.hero_signed_in_generic": "З поверненням",
  "quiz.home.hero_signed_in_named": "Вітаємо, {name}",
  "quiz.home.hero_signed_in_subtitle":
    "Створюйте й керуйте квізами для ваших навчальних сесій.",
  "quiz.home.hero_subtitle":
    "Запрошуйте учасників електронною поштою. Вони вчаться та проходять тест.",
  "quiz.home.hero_title": "Навчальні тести з ваших документів",
  "quiz.home.label_display_name": "Ім’я для відображення",
  "quiz.home.label_user_id": "Ідентифікатор користувача",
  "quiz.home.link_my_quizzes": "Мої тести",
  "quiz.home.link_view_existing_quizzes": "Переглянути наявні квізи",
  "quiz.home.link_new_training_quiz":
    "Запустити майстер навчального тесту (рекомендовано)",
  "quiz.home.logout": "Вийти",
  "quiz.home.logout_failed": "Не вдалося вийти. Спробуйте ще раз.",
  "quiz.home.logout_pending": "Вихід...",
  "quiz.home.participant_guidance_body":
    "Учасникам надішлють електронний лист із посиланням на квіз.",
  "quiz.home.participant_guidance_summary": "Як приєднуються учасники",
  "quiz.home.role_organizers_bullet_1": "Завантажуєте навчальний матеріал.",
  "quiz.home.role_organizers_bullet_2":
    "Формуйте пул питань та надсилайте запрошення.",
  "quiz.home.role_organizers_title": "Організатори",
  "quiz.home.role_participants_bullet_1": "Відкривайте посилання ви‑листі.",
  "quiz.home.role_participants_bullet_2": "Завершіть вікторину.",
  "quiz.home.role_participants_title": "Учасники",
  "quiz.home.session_error": "Не вдалося отримати стан входу.",
  "quiz.home.signed_in_title": "Обліковий запис",
  "quiz.home.skip_to_main": "Перейти до основного змісту",
  "quiz.my_quizzes.title": "Мої тести",
  "quiz.my_quizzes.loading": "Завантаження тестів…",
  "quiz.my_quizzes.empty":
    "Поки немає чернеток. Створіть тест, щоб додати навчальний матеріал. Назву можна взяти з першого завантаженого файлу; її можна змінити тут будь-коли до публікації.",
  "quiz.my_quizzes.feature_off":
    "Навчальні тести на цьому розгортанні вимкнено.",
  "quiz.my_quizzes.sign_in_required": "Увійдіть, щоб керувати тестами.",
  "quiz.my_quizzes.load_failed": "Не вдалося завантажити тести.",
  "quiz.my_quizzes.create_submit": "Створити тест",
  "quiz.my_quizzes.create_failed":
    "Не вдалося створити чернетку. Спробуйте ще раз.",
  "quiz.my_quizzes.quiz_title_field": "Назва тесту",
  "quiz.my_quizzes.save_title": "Зберегти назву",
  "quiz.my_quizzes.untitled_placeholder":
    "Без назви — із першого файлу або введіть вручну",
  "quiz.my_quizzes.title_save_failed":
    "Не вдалося зберегти назву. Спробуйте ще раз.",
  "quiz.my_quizzes.quiz_status_draft": "Чернетка",
  "quiz.my_quizzes.quiz_status_published": "Опубліковано",
  "quiz.my_quizzes.quiz_status_other": "{status}",
  "quiz.my_quizzes.summary_with_pipeline": "{lifecycle} · {pipeline}",
  "quiz.my_quizzes.generation_phase_running": "Генеруємо запитання",
  "quiz.my_quizzes.generation_phase_failed": "Збій генерації",
  "quiz.my_quizzes.generation_phase_queued": "Генерація в черзі",
  "quiz.my_quizzes.generation_phase_other": "{phase}",
  "quiz.my_quizzes.created_line": "Створено {date}",
  "quiz.my_quizzes.loading_more": "Завантаження…",
  "quiz.detail.back_my_quizzes": "Назад до «Мої тести»",
  "quiz.detail.loading": "Завантаження тесту...",
  "quiz.detail.sign_in_required": "Увійдіть, щоб переглянути цей тест.",
  "quiz.detail.not_found": "Тест не знайдено або немає доступу.",
  "quiz.detail.load_failed": "Не вдалося завантажити дані тесту.",
  "quiz.detail.recipients_failed": "Не вдалося завантажити список учасників.",
  "quiz.detail.created_line": "Створено {date}",
  "quiz.detail.quiz_id_line": "Ідентифікатор тесту: {quiz_id}",
  "quiz.detail.status_line": "Статус тесту: {status}",
  "quiz.detail.title_edit_aria": "Редагувати назву тесту",
  "quiz.detail.title_edit_glyph": "\u270E",
  "quiz.detail.title_confirm_aria": "Зберегти назву",
  "quiz.detail.title_confirm_glyph": "\u2713",
  "quiz.detail.title_cancel_aria": "Скасувати редагування",
  "quiz.detail.title_cancel_glyph": "\u2715",
  "quiz.detail.open_wizard_add_recipients":
    "Відкрити майстер, щоб додати одержувачів або надіслати запрошення",
  "quiz.detail.pool_heading": "Пул питань",
  "quiz.detail.pool_summary":
    "Активні: {active}. Усього збережено: {total}. Неактивні (не витягуються): {inactive}.",
  "quiz.detail.pool_empty": "Немає активних питань у пулі.",
  "quiz.detail.roster_heading": "Кандидати на тест",
  "quiz.detail.roster_empty": "Поки що немає призначень.",
  "quiz.detail.roster_empty_hint_wizard":
    "Відкрийте майстер, щоб запросити людей.",
  "quiz.detail.col_email": "Електронна пошта",
  "quiz.detail.col_invitation": "Запрошення",
  "quiz.detail.col_attempt": "Спроба",
  "quiz.detail.col_completed": "Завершено",
  "quiz.detail.col_invite": "Посилання",
  "quiz.detail.completed_dash": "-",
  "quiz.detail.invitation_sent": "Надіслано",
  "quiz.detail.invitation_not_sent": "Не надіслано",
  "quiz.detail.attempt_pass": "Складено",
  "quiz.detail.attempt_fail": "Не складено",
  "quiz.detail.attempt_in_progress": "Триває",
  "quiz.detail.attempt_not_submitted": "Не розпочато",
  "quiz.detail.transcript_open_aria":
    "Відкрити протокол надісланого тесту для {email}",
  "quiz.detail.transcript_title": "Протокол тесту",
  "quiz.detail.transcript_close": "Закрити",
  "quiz.detail.transcript_fullscreen": "Повна сторінка",
  "quiz.detail.transcript_fullscreen_aria":
    "Відкрити цей протокол на окремій сторінці",
  "quiz.detail.transcript_back_to_quiz": "Назад до тесту",
  "quiz.detail.transcript_loading": "Завантаження протоколу…",
  "quiz.detail.transcript_error": "Не вдалося завантажити протокол.",
  "quiz.detail.transcript_meta_line": "{email} · {date}",
  "quiz.detail.transcript_attempt_id": "ID спроби: {id}",
  "quiz.detail.transcript_outcome_passed": "Результат: здано",
  "quiz.detail.transcript_outcome_failed": "Результат: не здано",
  "quiz.detail.transcript_score": "Бали: {percent}%",
  "quiz.detail.transcript_selected_option": "Відповідь учасника: {text}",
  "quiz.detail.transcript_correct_option": "Правильна відповідь: {text}",
  "quiz.detail.transcript_no_selection": "(Відповідь не записано)",
  "quiz.detail.transcript_mark_correct": "Позначено як вірно",
  "quiz.detail.transcript_mark_incorrect": "Позначено як невірно",
  "quiz.detail.transcript_signing_area_aria":
    "Зона підпису (місце для підписів від руки після друку)",
  "quiz.detail.get_invite_link": "Отримати посилання",
  "quiz.detail.invite_link_confirm":
    "Створити нове посилання-запрошення? Попередні посилання для цього призначення перестануть діяти.",
  "quiz.detail.invite_link_copied": "Посилання скопійовано в буфер обміну.",
  "quiz.detail.invite_link_manual_copy": "Скопіюйте це посилання:",
  "quiz.detail.invite_link_failed":
    "Не вдалося отримати посилання. Спробуйте ще раз.",
  "quiz.detail.invite_link_no_origin":
    "Це розгортання не може формувати посилання (немає публічної URL сайту). Попросіть оператора налаштувати QUIZ_INVITE_PUBLIC_ORIGIN.",
  "quiz.detail.choice_correct": "Правильно: {text}",
  "quiz.wizard.page_title": "Налаштування навчального тесту",
  "quiz.wizard.back_my_quizzes": "До списку моїх тестів",
  "quiz.wizard.progress": "Крок {step} з {total}",
  "quiz.wizard.intro_lead":
    "Ми проведемо вас крок за кроком: підтвердити назву тесту, коротко побачити завантаження й наступні автоматичні кроки, вставити адреси одержувачів і надіслати запрошення.",
  "quiz.wizard.create_draft_button": "Створити чернетку й почати",
  "quiz.wizard.create_failed":
    "Не вдалося створити чернетку тесту. Спробуйте ще раз.",
  "quiz.wizard.loading_quiz": "Завантаження тесту...",
  "quiz.wizard.quiz_missing": "Не вдалося завантажити цей тест.",
  "quiz.wizard.need_sign_in": "Увійдіть знову через домашню сторінку.",
  "quiz.wizard.preview_note":
    "Генерація, перевірка пулу та повні перевірки публікації ще розвиваються разом із API. Листи одержувачам надсилаються через SES, коли оператори встановлять QUIZ_SES_MAIL_FROM. Завантаження навчальних матеріалів потребують бакенд-бакету матеріалів (стек оператора).",
  "quiz.wizard.step_title_name": "Назвіть тест",
  "quiz.wizard.step_title_help":
    "Назву пізніше можна взяти з завантажених файлів; уточніть зараз, щоб учасники впізнавали тест у запрошеннях.",
  "quiz.wizard.save_title_continue": "Зберегти назву й продовжити",
  "quiz.wizard.step_training_heading": "Навчальний матеріал",
  "quiz.wizard.step_training_body":
    "Завантажте до трьох файлів .txt (простий текст UTF-8), .pdf або .xlsx. Дочекайтеся стану «Готово» для кожного файлу, потім натисніть «Далі». Відскановані PDF без вбудованого тексту можуть дати мало або зовсім не дати тексту для вилучення.",
  "quiz.wizard.step_generation_heading": "Параметри генерації та пул питань",
  "quiz.wizard.step_generation_body":
    "Задайте, скільки запитань бачить учасник і яку мають форму відповіді, потім згенеруйте чернетки питань з типом вибору з готових навчальних файлів. Відредагуйте пул, доки не буде достатньо активних питань, і продовжуйте.",
  "quiz.wizard.generation_pipeline_status": "Етап генерації: {status}",
  "quiz.wizard.generation_settings_heading": "Параметри генерації тесту",
  "quiz.wizard.generation_settings_hint":
    "Типові значення підходять для більшості тестів; змінюйте лише коли потрібна інша довжина чи форма.",
  "quiz.wizard.generation_questions_per_attempt_label": "Запитань на тест",
  "quiz.wizard.generation_pool_count_label": "Розмір пулу запитань",
  "quiz.wizard.generation_pool_count_hint":
    "Типово подвоєно відносно кількості запитань у кожному тесті; кожному користувачу показують випадкову вибірку.",
  "quiz.wizard.generation_shape_heading": "Форма запитання",
  "quiz.wizard.generation_option_count_label":
    "Варіантів відповіді на запитання",
  "quiz.wizard.generation_min_correct_label": "Мінімум правильних відповідей",
  "quiz.wizard.generation_max_correct_label": "Максимум правильних відповідей",
  "quiz.wizard.generation_shape_invalid":
    "Виправте форму запитання: потрібно 1 ≤ мінімум правильних ≤ максимум правильних ≤ кількість варіантів.",
  "quiz.wizard.generation_single_correct_note":
    "Автоматична генерація як і раніше створює один повністю правильний варіант на запитання.",
  "quiz.wizard.generation_config_label":
    "Необов’язкові параметри генерації (JSON-об’єкт, об’єднується з конфігурацією тесту)",
  "quiz.wizard.generation_config_placeholder": "{}",
  "quiz.wizard.generation_queue_button":
    "Згенерувати питання з уривків навчального матеріалу",
  "quiz.wizard.generation_busy": "Надсилання…",
  "quiz.wizard.generation_json_invalid":
    "Параметри мають бути коректним синтаксисом JSON-об’єкта.",
  "quiz.wizard.generation_failed":
    "Не вдалося поставити генерацію в чергу. Спробуйте ще раз.",
  "quiz.wizard.generation_material_not_ready":
    "Усі навчальні файли мають бути в стані «Готово» перед генерацією.",
  "quiz.wizard.generation_locked":
    "Після публікації цей тест заблоковано для змін.",
  "quiz.wizard.generation_queued":
    "Генерацію прийнято. Перегляньте оновлений пул нижче й продовжіть.",
  "quiz.wizard.generation_completed_failed":
    "Сервер позначив цю спробу генерації як невдалу (див. журнали оператора, якщо доступні). Змініть параметри вище або повторіть після виправлення уривків.",
  "quiz.wizard.generation_done_reload":
    "Генерацію завершено; перегляньте оновлений пул.",
  "quiz.wizard.generation_failed_banner":
    "Остання генерація не вдалася. Виправте уривки навчального матеріалу або параметри генерації й повторіть.",
  "quiz.wizard.generation_running_notice":
    "Генерація питань читає ваші уривки в стані READY — зачекайте, поки бекенд обробить запит.",
  "quiz.wizard.generation_reset_hint":
    "Після ліміту Lambda та невеликого запасу (зазвичай кілька хвилин) можна скинути, якщо все ще «running». Не скидайте, якщо впевнені, що генерація триває.",
  "quiz.wizard.generation_reset_stuck_button": "Скинути завислу генерацію",
  "quiz.wizard.generation_reset_busy": "Скидаємо стан генерації…",
  "quiz.wizard.generation_reset_failed":
    "Не вдалося скинути стан. Спробуйте ще раз.",
  "quiz.wizard.generation_reset_too_soon":
    "Генерація на сервері ще може тривати. Зачекайте кілька хвилин, повторіть або оновіть сторінку.",
  "quiz.wizard.pool_readonly_while_running":
    "Редагування пулу призупинено під час генерації.",
  "quiz.wizard.pool_edit": "Редагувати",
  "quiz.wizard.pool_save_edit": "Зберегти зміни",
  "quiz.wizard.pool_cancel_edit": "Скасувати",
  "quiz.wizard.generation_in_progress_blocked":
    "Для цього тесту генерація вже виконується.",
  "quiz.wizard.generation_continue_blocked":
    "Поставте генерацію в чергу перед продовженням.",
  "quiz.wizard.generation_continue_blocked_pool":
    "Додайте достатньо активних питань, щоб розмір пулу відповідав questions_per_attempt, перш ніж продовжувати.",
  "quiz.wizard.pool_section_title": "Чернетковий пул питань",
  "quiz.wizard.pool_section_help":
    "Кожен елемент має містити рівно {n, plural, one {# варіант відповіді} few {# варіанти відповіді} many {# варіантів відповіді} other {# варіантів відповіді}} (поле option_count у конфігурації, типово чотири).",
  "quiz.wizard.pool_empty":
    "Ще немає чернеток питань. Додайте принаймні одну нижче.",
  "quiz.wizard.pool_stem_placeholder": "Текст запитання для учасників",
  "quiz.wizard.pool_choice_label": "Варіант {n}",
  "quiz.wizard.pool_correct_label":
    "Правильний варіант (позиція з базою 1 у списку вище)",
  "quiz.wizard.pool_correct_multi_hint":
    "Mark every choice that should count as correct (within the minimum and maximum you set in generation settings).",
  "quiz.wizard.pool_choices_aria": "Варіанти відповіді",
  "quiz.wizard.pool_correct_option_mark": "Правильно",
  "quiz.wizard.pool_item_meta":
    "{count, plural, one {# варіант} few {# варіанти} many {# варіантів} other {# варіантів}}; правильна позиція {pos}",
  "quiz.wizard.pool_inactive_marker": "(неактивне)",
  "quiz.wizard.pool_delete": "Прибрати",
  "quiz.wizard.pool_add_aria": "Додати запитання",
  "quiz.wizard.pool_add_button": "Додати запитання",
  "quiz.wizard.pool_busy": "Збереження пулу…",
  "quiz.wizard.pool_failed":
    "Не вдалося оновити пул. Перевірте поля й спробуйте ще раз.",
  "quiz.wizard.pool_validation":
    "Заповніть формулювання та кожен варіант перед додаванням.",
  "quiz.wizard.pool_publish_hint":
    "Активних питань: {active}. Потрібно щонайменше {needed} активних питань для цієї конфігурації тесту перед запрошеннями.",
  "quiz.wizard.publish_pool_too_small":
    "Активний пул менший за questions_per_attempt. Поверніться до кроку 3 і додайте питання.",
  "quiz.wizard.step_invite_heading": "Одержувачі та запрошення",
  "quiz.wizard.step_invite_body":
    "Вставте по одній електронній адресі учасника на рядок. Ми прибираємо дублікати й дотримуємося серверного обмеження.",
  "quiz.wizard.recipients_label": "Адреси одержувачів",
  "quiz.wizard.recipients_placeholder":
    "person1@organization.org\nperson2@organization.org",
  "quiz.wizard.recipients_hint":
    "Порожні рядки ігноруються; дублікати видаляються; максимум 20 прийнятих адрес.",
  "quiz.wizard.publish_button": "Опублікувати й надіслати запрошення",
  "quiz.wizard.publish_failed":
    "Публікація не вдалася. Перевірте адреси й повторіть.",
  "quiz.wizard.publish_conflict": "Цей тест уже має надіслані запрошення.",
  "quiz.wizard.publish_validation":
    "Після прибирання дублікатів одна чи кілька адрес виглядають некоректно.",
  "quiz.wizard.back_step": "Назад",
  "quiz.wizard.continue": "Далі",
  "quiz.wizard.success_title": "Запрошення збережено",
  "quiz.wizard.success_lead_publish":
    "Ми зберегли кожне призначення й поставили листи в чергу згідно з налаштуваннями розгортання нижче.",
  "quiz.wizard.success_lead_repeat":
    "У цьому тесті {count, plural, one {# збережене запрошення} few {# збережені запрошення} many {# збережених запрошень} other {# збережених запрошень}}. Після публікації знову відкрийте майстер, щоб переглянути чекліст.",
  "quiz.wizard.mail_notice_ses_optional":
    "Якщо оператори встановили QUIZ_SES_MAIL_FROM (і ідентичності SES перевірені поза пісочницею), SES надсилає HTTPS-посилання magic link.",
  "quiz.wizard.mail_notice_skipped":
    "Вихідні листи SES у цьому середовищі вимкнено; налаштуйте QUIZ_SES_MAIL_FROM і дозволи IAM SES для реальної доставки.",
  "quiz.wizard.mail_sent": "Лист надіслано",
  "quiz.wizard.mail_failed": "Не вдалося надіслати",
  "quiz.wizard.mail_skipped": "Пропущено (немає SES)",
  "quiz.wizard.col_email": "Одержувач",
  "quiz.wizard.col_delivery": "Стан листа",
  "quiz.wizard.back_to_my_quizzes": "Назад до «Мої тести»",
  "quiz.wizard.view_quiz_detail": "Деталі тесту",
  "quiz.wizard.material_docs_heading": "Завантажені файли",
  "quiz.wizard.material_empty":
    "Файлів ще немає — додайте принаймні один документ нижче.",
  "quiz.wizard.material_upload_pick": "Оберіть файл (.txt, .pdf, .docx, .xlsx)",
  "quiz.wizard.material_choose_file": "Обрати файл",
  "quiz.wizard.material_drop_aria":
    "Додайте навчальні документи перетягуванням сюди або через вибір файлу",
  "quiz.wizard.material_drop_hint":
    "Перетягніть файли сюди (.txt, .pdf, .docx, .xlsx) або",
  "quiz.wizard.material_busy": "Завантаження…",
  "quiz.wizard.material_no_file": "Спочатку оберіть файл.",
  "quiz.wizard.material_failed":
    "Завантаження не завершилося. Спробуйте ще раз або оберіть інший файл.",
  "quiz.wizard.material_put_failed":
    "Пряме завантаження в сховище не вдалося. Спробуйте ще раз.",
  "quiz.wizard.material_storage_off":
    "Сховище навчальних матеріалів не налаштоване на цьому розгортанні (оператор: задайте QUIZ_MATERIAL_BUCKET на Lambda).",
  "quiz.wizard.material_limit":
    "Досягнуто максимуму навчальних документів для цього тесту.",
  "quiz.wizard.material_next_blocked":
    "Продовжуйте лише після того, як кожен файл матиме стан «Готово» (усі вилучення тексту успішні).",
  "quiz.wizard.material_delete_aria": "Прибрати файл",
  "quiz.wizard.material_remove_failed":
    "Не вдалося видалити файл. Спробуйте ще раз.",
  "quiz.wizard.material_state_AWAITING_BYTES": "Очікує завантаження",
  "quiz.wizard.material_state_INGESTING": "Обробка",
  "quiz.wizard.material_state_READY": "Готово",
  "quiz.wizard.material_state_FAILED": "Помилка",
  "quiz.health.heading": "Стан бекенду",
  "quiz.health.loading": "GET /api/v1/health...",
  "quiz.health.httpStatus": "HTTP-стан: {status}",
  "quiz.health.responseBody": "Тіло відповіді JSON",
  "quiz.health.networkError": "Не вдалося звернутися до API.",
  "quiz.health.notJson": "Відповідь не був коректним JSON.",
  "quiz.organizer.sign_in.title": "Увійти",
  "quiz.organizer.sign_in.lead": "Оберіть постачальника, щоб продовжити.",
  "quiz.organizer.sign_in.google": "Продовжити з Google",
  "quiz.organizer.sign_in.github": "Продовжити з GitHub",
  "quiz.organizer.sign_in.bootstrap.heading":
    "Облікові дані оператора (середовище)",
  "quiz.organizer.sign_in.bootstrap.lead":
    "Для аварійного доступу, коли OAuth недоступний.",
  "quiz.organizer.sign_in.bootstrap.username_label": "Ім'я користувача",
  "quiz.organizer.sign_in.bootstrap.password_label": "Пароль",
  "quiz.organizer.sign_in.bootstrap.submit": "Увійти",
  "quiz.organizer.sign_in.nav_home": "Головна",
  "quiz.components.button.sample_label": "Продовжити",
  "quiz.components.button.danger_sample": "Видалити",
  "quiz.components.icon_button.sample_aria": "Додаткові дії",
  "quiz.components.icon_button.sample_glyph": "+",
  "quiz.ui_demo.heading": "Бібліотека UI-компонентів",
  "quiz.ui_demo.lead":
    "Статичний макет спільних компонентів quiz-frontend для усіх маршрутів.",
  "quiz.ui_demo.subheading_buttons": "Кнопки",
  "quiz.ui_demo.caption_enabled": "Продуктивна основна",
  "quiz.ui_demo.caption_disabled": "Вимкнена основна",
  "quiz.ui_demo.caption_app_link": "Текстове посилання",
  "quiz.ui_demo.caption_btn_danger": "Кнопка небезпеки",
  "quiz.ui_demo.caption_btn_ghost": "Прозора кнопка",
  "quiz.ui_demo.caption_btn_secondary": "Додаткова контурна кнопка",
  "quiz.ui_demo.caption_icon_btn": "Кнопка-іконка",
  "quiz.ui_demo.caption_layout_card": "Картка поверхні",
  "quiz.ui_demo.caption_layout_headings": "Рівні заголовків",
  "quiz.ui_demo.caption_layout_stack": "Вертикальний стек",
  "quiz.ui_demo.caption_layout_text": "Основний та приглушений текст",
  "quiz.ui_demo.sample_app_link_label": "Відкрити сторінку перевірки здоров'я",
  "quiz.ui_demo.sample_card_body": "Приклад вмісту картки.",
  "quiz.ui_demo.sample_heading_h3": "Заголовок третього рівня",
  "quiz.ui_demo.sample_heading_h4": "Заголовок четвертого рівня",
  "quiz.ui_demo.sample_text_body": "Основний текст опису.",
  "quiz.ui_demo.sample_text_muted": "Додатковий приглушений текст.",
  "quiz.ui_demo.skip_to_main": "Перейти до головного вмісту",
  "quiz.ui_demo.stack_line_one": "Рядок стеку один",
  "quiz.ui_demo.stack_line_two": "Рядок стеку два",
  "quiz.ui_demo.subheading_forms": "Форми",
  "quiz.ui_demo.subheading_layout": "Макет і типографія",
  "quiz.ui_demo.caption_field_file": "Файл з підписом",
  "quiz.ui_demo.caption_field_radio": "Група перемикачей",
  "quiz.ui_demo.caption_field_select": "Випадаючий список",
  "quiz.ui_demo.caption_field_text": "Текст з підказкою",
  "quiz.ui_demo.caption_field_text_invalid": "Текст з помилкою",
  "quiz.ui_demo.caption_field_textarea": "Багаторядкове поле",
  "quiz.ui_demo.caption_checkbox": "Прапорець",
  "quiz.ui_demo.forms_error_required": "Ім'я обов'язкове.",
  "quiz.ui_demo.forms_file_hint": "Для демо лише .txt.",
  "quiz.ui_demo.forms_hint_name": "Відображається як ім'я у формах.",
  "quiz.ui_demo.forms_label_agree": "Погоджую демо-умовами",
  "quiz.ui_demo.forms_label_bio": "Біографія",
  "quiz.ui_demo.forms_label_locale": "Мова попередження",
  "quiz.ui_demo.forms_label_name": "Ім'я для відображення",
  "quiz.ui_demo.forms_label_upload": "Файл навчання",
  "quiz.ui_demo.forms_placeholder_bio": "Короткий текст біографії",
  "quiz.ui_demo.forms_placeholder_name": "Ada Lovelace",
  "quiz.ui_demo.forms_radio_a": "Варіант A",
  "quiz.ui_demo.forms_radio_b": "Варіант B",
  "quiz.ui_demo.forms_radio_legend": "Оберіть один варіант",
  "quiz.ui_demo.forms_select_de": "Німецька",
  "quiz.ui_demo.forms_select_en": "Англійська",
  "quiz.ui_demo.alert_error_body": "Виправте виділені поля перед продовженням.",
  "quiz.ui_demo.alert_error_title": "Не вдалося зберегти",
  "quiz.ui_demo.alert_info_body": "Фонові завдання можуть тривати до хвилини.",
  "quiz.ui_demo.alert_info_title": "Зверніть увагу",
  "quiz.ui_demo.alert_success_body": "Чернетку успішно збережено.",
  "quiz.ui_demo.alert_success_title": "Збережено",
  "quiz.ui_demo.alert_warn_body":
    "Розмір пулу близький до мінімуму, потрібного для публікації.",
  "quiz.ui_demo.alert_warn_title": "Перевірте розмір пулу",
  "quiz.ui_demo.caption_alert_error": "Сповіщення про помилку",
  "quiz.ui_demo.caption_alert_info": "Інформаційне сповіщення",
  "quiz.ui_demo.caption_alert_success": "Сповіщення про успіх",
  "quiz.ui_demo.caption_alert_warning": "Попередження",
  "quiz.ui_demo.caption_badges": "Статусні значки",
  "quiz.ui_demo.caption_empty_demo": "Порожній стан",
  "quiz.ui_demo.caption_loading_row": "Рядок завантаження",
  "quiz.ui_demo.caption_progress_demo": "Рядок прогресу",
  "quiz.ui_demo.caption_table_demo": "Проста таблиця",
  "quiz.ui_demo.display_badge_neutral": "Чернетка",
  "quiz.ui_demo.display_badge_success": "Готово",
  "quiz.ui_demo.display_badge_warning": "У черзі",
  "quiz.ui_demo.display_empty_body":
    "Створіть вікторину, щоб тут з’явилися чернетки.",
  "quiz.ui_demo.display_empty_title": "Поки немає вікторин",
  "quiz.ui_demo.display_progress_text": "Крок 2 з 5 (демо).",
  "quiz.ui_demo.display_table_col_email": "Електронна пошта",
  "quiz.ui_demo.display_table_col_state": "Стан",
  "quiz.ui_demo.display_table_row1_email": "a@example.com",
  "quiz.ui_demo.display_table_row1_state": "SENT",
  "quiz.ui_demo.display_table_row2_email": "b@example.com",
  "quiz.ui_demo.display_table_row2_state": "NOT_SENT",
  "quiz.ui_demo.loading_label": "Завантаження вікторин...",
  "quiz.ui_demo.subheading_display": "Відображення даних",
  "quiz.ui_demo.subheading_feedback": "Сповіщення та завантаження",
  "quiz.ui_demo.locale_picker_label": "Мова інтерфейсу",
  "quiz.ui_demo.caption_disclosure": "Розкривний блок",
  "quiz.ui_demo.caption_mc_option": "Плитки варіантів з одним вибором",
  "quiz.ui_demo.caption_modal": "Модальне вікно",
  "quiz.ui_demo.caption_pool_row": "Рядок елемента пулу",
  "quiz.ui_demo.caption_reader": "Оболонка читача навчальних матеріалів",
  "quiz.ui_demo.domain_mc_opt_a": "Текст варіанту A",
  "quiz.ui_demo.domain_mc_opt_b": "Текст варіанту B",
  "quiz.ui_demo.domain_pool_meta": "4 варіанти · активний",
  "quiz.ui_demo.domain_pool_stem":
    "Який перший крок у чеклісті реагування на інцидент?",
  "quiz.ui_demo.domain_reader_sample":
    "Уривок навчання: завжди перевіряйте особу перед наданням доступу.",
  "quiz.ui_demo.overlay_disclosure_body":
    "Додатковий текст політики можна залишити згорнутим.",
  "quiz.ui_demo.overlay_disclosure_summary": "Показати деталі політики",
  "quiz.ui_demo.overlay_modal_body":
    "Нативний елемент dialog для підтверджень.",
  "quiz.ui_demo.overlay_modal_close": "Закрити",
  "quiz.ui_demo.overlay_modal_open": "Відкрити демо-діалог",
  "quiz.ui_demo.overlay_modal_title": "Демо-діалог",
  "quiz.ui_demo.subheading_domain": "Віджети для вікторин",
  "quiz.ui_demo.subheading_overlays": "Накладання",
  "quiz.participant.answer_all":
    "Відповідь на всі запитання перед надсиланням.",
  "quiz.participant.error_load":
    "Запрошення може бути недійсним або простроченим. Скористайтеся посиланням з останнього листа або зверніться до організатора.",
  "quiz.participant.error_missing_token":
    "Потрібне повне посилання запрошення з токеном у параметрах запиту.",
  "quiz.participant.error_title": "Не вдалося відкрити посилання",
  "quiz.participant.loading": "Завантаження призначення…",
  "quiz.participant.name_back_material": "Назад до навчальних матеріалів",
  "quiz.participant.name_continue": "Далі",
  "quiz.participant.name_heading": "Ваші дані",
  "quiz.participant.name_hint":
    "Показується у підсумку результатів, якщо організатор налаштував підпис для звітів.",
  "quiz.participant.name_intro":
    "Уведіть імʼя, яке організатор має бачити для цієї спроби.",
  "quiz.participant.name_label": "Ваше імʼя",
  "quiz.participant.name_placeholder": "наприклад Jordan Smith",
  "quiz.participant.name_required": "Уведіть імʼя, щоб продовжити.",
  "quiz.participant.nav_back": "Назад",
  "quiz.participant.nav_next": "Далі",
  "quiz.participant.abort_attempt": "Скасувати спробу",
  "quiz.participant.abort_attempt_confirm":
    "Зупинити цю спробу? Ваші відповіді буде відкинуто. Якщо ви вже завершили спробу раніше, ви побачите той результат.",
  "quiz.participant.abort_attempt_aria":
    "Скасувати цю спробу тесту без надсилання відповідей",
  "quiz.participant.progress_label": "Запитання {current} з {total}",
  "quiz.participant.question_heading": "Запитання",
  "quiz.participant.resume_attempt": "Продовжити вікторину",
  "quiz.participant.result_failed": "Не складено",
  "quiz.participant.result_passed": "Успішно",
  "quiz.participant.result_ident_quiz_label": "\u0422\u0435\u0441\u0442",
  "quiz.participant.result_ident_participant_label":
    "\u0406\u043c\u02bc\u044f \u0443\u0447\u0430\u0441\u043d\u0438\u043a\u0430",
  "quiz.participant.result_ident_participant_not_set":
    "\u0406\u043c\u02bc\u044f \u043d\u0435 \u0432\u043a\u0430\u0437\u0430\u043d\u043e",
  "quiz.participant.result_training_heading":
    "\u041d\u0430\u0432\u0447\u0430\u043b\u044c\u043d\u0456 \u043c\u0430\u0442\u0435\u0440\u0456\u0430\u043b\u0438 \u0446\u044c\u043e\u0433\u043e \u0442\u0435\u0441\u0442\u0443",
  "quiz.participant.result_transcript_heading":
    "\u042f\u043a \u0432\u0438 \u0432\u0456\u0434\u043f\u043e\u0432\u0456\u043b\u0438",
  "quiz.participant.transcript_option_aria":
    "\u0412\u0430\u0448 \u0432\u0430\u0440\u0456\u0430\u043d\u0442 \u0432\u0456\u0434\u043f\u043e\u0432\u0456\u0434\u0456 {n}: {text}",
  "quiz.participant.transcript_question_correct":
    "\u0412\u0456\u0440\u043d\u043e",
  "quiz.participant.transcript_question_wrong":
    "\u041d\u0435\u0432\u0456\u0440\u043d\u043e",
  "quiz.participant.result_transcript_selection_note":
    "\u0414\u0435\u0442\u0430\u043b\u044c\u043d\u0456 \u0440\u0435\u0437\u0443\u043b\u044c\u0442\u0430\u0442\u0438 \u0437\u0430 \u043a\u043e\u0436\u043d\u0438\u043c \u0437\u0430\u043f\u0438\u0442\u0430\u043d\u043d\u044f\u043c \u043d\u0435\u0434\u043e\u0441\u0442\u0443\u043f\u043d\u0456 \u0443 \u0446\u044c\u043e\u043c\u0443 \u0440\u0435\u0436\u0438\u043c\u0456\u002e \u041d\u0438\u0436\u0447\u0435 \u043f\u043e\u043a\u0430\u0437\u0430\u043d\u043e \u043b\u0438\u0448\u0435 \u0432\u0430\u0440\u0456\u0430\u043d\u0442\u0438\u002c \u044f\u043a\u0456 \u0432\u0438 \u043e\u0431\u0440\u0430\u043b\u0438\u002e",
  "quiz.participant.result_retry":
    "\u0421\u043f\u0440\u043e\u0431\u0443\u0432\u0430\u0442\u0438 \u0449\u0435 \u0440\u0430\u0437",
  "quiz.participant.score_label": "Бал: {percent}%",
  "quiz.participant.score_label_with_threshold":
    "\u0411\u0430\u043b: {percent}% \u2014 \u043f\u0440\u043e\u0445\u0456\u0434\u043d\u0438\u0439 \u043f\u043e\u0440\u0456\u0433 {passPercent}%",
  "quiz.participant.skip_to_main": "Перейти до основного вмісту",
  "quiz.participant.start_attempt": "Почати вікторину",
  "quiz.participant.submit_assignment_issued":
    "\u0417\u0430\u043f\u0440\u043e\u0448\u0435\u043d\u043d\u044f \u043d\u0430\u0434\u0456\u0441\u043b\u0430\u043d\u043e {datetime}",
  "quiz.participant.submit_answers": "Надіслати відповіді",
  "quiz.participant.submitting": "Надсилання…",
  "quiz.participant.training_intro":
    "Торкніться кожного посилання файлу, щоб зберегти копію навчального документа перед початком.",
  "quiz.participant.training_resume_intro":
    "Ви вже розпочали цю вікторину. За потреби перегляньте навчальні матеріали знову й продовжіть там, де зупинилися.",
  "quiz.participant.training_docs_empty":
    "На цей тест навчання ще немає жодних документів.",
  "quiz.participant.training_doc_download_aria":
    "Завантажити навчальний документ {filename}",
  "quiz.participant.training_heading": "Навчальні матеріали",
};
